export class IUserDepartment {   
    email : string;
    userDepartments : IDepartment[];
    constructor(){}
}

export class IDepartment {   
    department : string;
}
